var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa7-solid:medal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10056 11.5918L1.91113 16.8776L5.04433 16.5583L7.03396 18.9996L9.0693 14.0858C7.0816 13.9659 5.31285 13.022 4.10056 11.5918Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8994 11.5918C13.6871 13.022 11.9183 13.9659 9.93066 14.0858L11.966 18.9996L13.9556 16.5583L17.0888 16.8776L14.8994 11.5918Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49985 4.16309C7.92327 4.16309 6.64062 5.44573 6.64062 7.02231C6.64062 8.59889 7.9233 9.8815 9.49985 9.8815C11.0764 9.8815 12.3591 8.59886 12.3591 7.02227C12.3591 5.44569 11.0764 4.16309 9.49985 4.16309Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 1C6.17923 1 3.47754 3.70176 3.47754 7.02265C3.47754 10.3435 6.1793 13.0453 9.50019 13.0453C12.8211 13.0453 15.5228 10.3435 15.5228 7.02265C15.5228 3.70176 12.8211 1 9.50016 1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedal);
export default __webpack_public_path__ + "static/media/icon-medal.8164529b7b9f832339f4de4c3927205f.svg";
export { ForwardRef as ReactComponent };